import { getBaseMetaTitle } from '@/environments'

const ListProgram = () => import('./Main')

const route = {
  path: '/archive/program',
  name: 'programArchive',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: ListProgram
}

export default route
